import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	Tooltip,
} from "@material-ui/core";
import { AddCircle } from "@material-ui/icons";
import React, { useState } from "react";
import { shallowEqual, useSelector } from "react-redux";
import Table, { buttonsStyle } from "../tables/table";
import CreatePartidaDialog from "./CreatePartidaDialog";

function getData(partidas) {
	let data = [];

	for (let i = 0; i < partidas.length; ++i) {
		const elem = {};
		const partida = partidas[i];

		elem.referencia = partida?.referencia;
		elem.descripcion = partida?.descripcion;
		elem.categoria = partida?.categoria?.descripcion;
		elem.id = partida?.id;

		data = data.concat(elem);
	}

	return data;
}

const PartidaTableDialog = (props) => {
	const { title, open, setOpen, data, onSelect } = props;

	const [openCreatePartidaDialog, setOpenCreatePartidaDialog] = useState(
		false
	);

	const loggedUser = useSelector(
		(store) => store.authentication?.user,
		shallowEqual
	);

	function buttonFormatter(cell) {
		const elem = data.find((item) => item.id === cell);
		return (
			<>
				<Tooltip title="Seleccionar">
					<Button
						style={buttonsStyle}
						size="small"
						onClick={(e) => {
							onSelect(cell);
							setOpen(false);
						}}
					>
						<AddCircle />
					</Button>
				</Tooltip>
			</>
		);
	}

	const columns = [
		{ dataField: "referencia", text: "Referencia", sort: true },
		{
			dataField: "descripcion",
			text: "Descripción",
			sort: true,
			headerAlign: "center",
			align: "center",
		},
		{
			dataField: "categoria",
			text: "Categoría",
			sort: true,
			headerAlign: "center",
			align: "center",
		},
		{ dataField: "id", text: "", formatter: buttonFormatter },
	];

	return (
		<>
			<Dialog
				fullWidth={true}
				maxWidth="xl"
				open={open}
				onClose={() => {
					setOpen(false);
				}}
				aria-labelledby="table-dialog"
				className="backdrop"
			>
				<DialogTitle id="table-dialog">
					<div className="d-flex justify-content-between">
						{"Partidas"}
						<button
							type="button"
							className="btn btn-primary"
							onClick={() => {
								setOpenCreatePartidaDialog(true);
							}}
						>
							Añadir nueva
						</button>
					</div>
				</DialogTitle>
				<DialogContent>
					{!data || !data.length ? (
						<p>{"No hay partidas disponibles."}</p>
					) : (
						<Table data={getData(data)} columns={columns} />
					)}
				</DialogContent>
				<DialogActions>
					<Button
						className="mr-2"
						onClick={() => {
							setOpen(false);
						}}
						variant="outlined"
					>
						Cancelar
					</Button>
					<br />
				</DialogActions>
			</Dialog>
			<CreatePartidaDialog
				open={openCreatePartidaDialog}
				setOpen={setOpenCreatePartidaDialog}
				onSave={(partidaId) => {
					onSelect(partidaId);
					setOpen(false);
				}}
			/>
		</>
	);
};
export default PartidaTableDialog;
